import React from 'react';
import { Box, Button, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useSuperDuper } from '../../context/SuperDuperContext';

const AGE_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'beginner', label: 'Beginner (1-5)', color: 'success' },
  { value: 'junior', label: 'Junior (6-9)', color: 'primary' },
  { value: 'senior', label: 'Senior (10-15)', color: 'secondary' }
];

const SubscriptionFilters = () => {
  const {
    subscriptionSubTab,
    handleSubscriptionSubTabChange,
    searchQuery,
    setSearchQuery,
    ageFilter,
    setAgeFilter
  } = useSuperDuper();

  return (
    <>
      {/* Nested Tabs for Subscription Views */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={subscriptionSubTab}
          onChange={handleSubscriptionSubTabChange}
          aria-label="subscription view tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: { xs: 40, sm: 48 },
            '& .MuiTab-root': {
              minHeight: { xs: 40, sm: 48 },
              minWidth: 'auto',
              px: { xs: 1.5, sm: 2 },
              textTransform: 'none',
              fontSize: { xs: '0.85rem', sm: '0.95rem' },
              fontWeight: 500
            }
          }}
        >
          <Tab label="Live" />
          <Tab label="Current Subscribers" />
          <Tab label="Cancelled" />
          <Tab label="Halted" />
        </Tabs>
      </Box>

      {/* Search Box for Live and Current Subscribers */}
      {(subscriptionSubTab === 0 || subscriptionSubTab === 1) && (
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search by email, phone, name, or subscription ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ maxWidth: 600 }}
            helperText="💡 Tip: You can search using email, phone number, customer name, or subscription ID"
          />
        </Box>
      )}

      {/* Helper Text for Current Subscribers */}
      {subscriptionSubTab === 1 && (
        <>
          <Box sx={{ mb: 3, p: { xs: 1.5, sm: 2 }, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #e0e0e0' }}>
            <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <span style={{ fontSize: '1.1rem' }}>ℹ️</span>
              Shows active subscriptions, cancelled subscriptions with payment created less than 1 month ago, and halted subscriptions created less than 1 month ago
            </Typography>
          </Box>

          {/* Age Category Filter */}
          <Box
            sx={{
              mb: 3,
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              alignItems: 'center'
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600, width: { xs: '100%', sm: 'auto' }, mr: { sm: 1 } }}>
              Filter by Age:
            </Typography>
            {AGE_FILTERS.map(({ value, label, color }) => (
              <Button
                key={value}
                variant={ageFilter === value ? 'contained' : 'outlined'}
                color={color}
                onClick={() => setAgeFilter(value)}
                size="small"
              >
                {label}
              </Button>
            ))}
          </Box>
        </>
      )}
    </>
  );
};

export default SubscriptionFilters;
